module.exports = __webpack_public_path__ + "images/Addpartner1_1f31d05.svg";